<template>
  <div>
    <div class="vx-row mt-5">
      <!-- Analista Responsável -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label for="Analista Responsável Terceiro" class="vs-select--label"
          >Analista Responsável Terceiro</label
        >
        <v-select
          :options="dominios.listResponsaveis"
          v-model="formCadastroTerceiro.idAnalista"
          name="Analista Responsável Terceiro"
          id="Analista Responsável Terceiro"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>

      <!-- Regulador Responsável -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label for="Regulador Responsável Terceiro" class="vs-select--label"
          >Regulador Responsável Terceiro</label
        >
        <v-select
          :options="dominios.listResponsaveis"
          v-model="formCadastroTerceiro.idRegulador"
          name="Regulador Responsável Terceiro"
          id="Regulador Responsável Terceiro"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>

      <!-- Sicronizar Eventos Cilia -->
      <div class="vx-col lg:w-1/6 w-full mb-2">
        <label class="vs-input--label">Sincronizar Eventos Cilia</label>
        <vs-switch
          v-model="formCadastroTerceiro.sincronizarCilia"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Tipo de Abertura -->
      <div class="vx-col lg:w-1/6 w-full mb-2">
        <label class="vs-input--label">Tipo de Abertura</label>
        <div class="inputData">
          <vs-input
            class="w-full"
            v-model="this.tipoAbertura"
            name="Tipo de Abertura"
            disabled
          />
        </div>
      </div>

      <div class="vx-col lg:w-1/6 w-full mb-2">
        <label class="vs-input--label">Data de Cadastro</label>
        <div class="inputData">
          <vs-input
            class="w-full"
            v-model="this.dataCadastroEvento"
            name="Data de Cadastro"
            disabled
          />
        </div>
      </div>
    </div>

    <div class="vx-row mt-5">
      <!-- Motivos do Evento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Motivo do Evento</label>
        <v-select
          class="selectStyle"
          :options="listMotivos"
          name="Motivo do Evento"
          id="Motivo do Evento"
          v-model="formCadastroTerceiro.idMotivoEvento"
          label="label"
          :reduce="(item) => item.id"
          disabled
        ></v-select>
      </div>

      <!-- Status do Evento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Status do Evento</label>
        <v-select
          class="selectStyle"
          :options="listSituacoes"
          name="Status do Evento"
          id="Status do Evento"
          v-model="formCadastroTerceiro.idStatus"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>

      <!-- Envolvimento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Envolvimento</label>
        <v-select
          class="selectStyle"
          :options="listEnvolvimentos"
          name="Envolvimento"
          id="Envolvimento"
          v-model="formCadastroTerceiro.idEnvolvimento"
          label="label"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
        ></v-select>
      </div>

      <!-- Data e Hora Evento -->
      <div class="vx-col lg:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Evento</label>
          <div class="inputData">
            <flat-pickr
              :config="configDateTimePickerDay"
              v-model="formCadastroTerceiro.dataEvento"
              placeholder="DD/MM/AAAA"
              name="Data do Evento"
            />
          </div>
        </div>

        <!-- Hora do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Evento</label>
          <div class="inputData">
            <vs-input
              class="w-full"
              v-model="formCadastroTerceiro.horaEvento"
              v-mask="'##:##'"
              maxlength="5"
              placeholder="HH:MM"
              name="Hora do Evento"
              @input="
                validaHoraMinuto(formCadastroTerceiro.horaEvento, 'horaEvento')
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mb-4">
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <!-- Razão caso condutor se considere culpado pelo sinistro -->
        <vs-textarea
          class="w-full"
          label="Caso o condutor se considere culpado pelo sinistro, informar a razão:"
          name="Caso o condutor se considere culpado pelo sinistro, informar a razão:"
          v-model="formCadastroTerceiro.razaoEnvolvidoCausouAcidente"
        />
      </div>
    </div>

    <div class="vx-row mb-4">
      <!-- Descrição detalhada do sinistro -->
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição detalhada do sinistro pelo terceiro"
          v-model="formCadastroTerceiro.descricaoDetalhadaEnvolvido"
        />
      </div>
    </div>

    <!-- Descrição do Evento para Controle Interno -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Aviso de evento terceiro"
          v-model="formCadastroTerceiro.descricaoEventoControleInterno"
        />
      </div>
    </div>

    <!-- Observações -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formCadastroTerceiro.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formCadastroTerceiro.historicos" />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../components/editor/config';

import HistoricoObservacao from './../../shared/components/HistoricoObservacao.vue';
import notify from '../../../../../utils/notify';
import formatDate from '../../../../../v2/utils/formatDate';

export default {
  props: ['formData', 'dominios'],
  components: { vSelect, flatPickr, HistoricoObservacao, VueEditor },
  watch: {
    formData(value) {
      if (!value.cadastroTerceiro) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO TERCEIRO FORM');
        return;
      }

      this.formCadastroTerceiro = Object.assign(
        this.formCadastroTerceiro,
        value.cadastroTerceiro,
      );

      if (this.formCadastroTerceiro.horaEvento) {
        this.formCadastroTerceiro.horaEvento =
          this.formCadastroTerceiro.horaEvento
            .split(':')
            .filter((value, index) => index < 2)
            .join(':');
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cadastroTerceiro = this.formCadastroTerceiro;
    },
  },
  data() {
    return {
      showComponent: true,
      formCadastroTerceiro: {
        idAnalista: null,
        idRegulador: null,
        sincronizarCilia: false,
        idMotivoEvento: null,
        idStatus: null,
        idEnvolvimento: null,
        dataEvento: null,
        horaEvento: null,
        dataHoraEvento: null,
        descricaoEventoControleInterno: null,
        observacao: null,
        historicos: [],
        direcaoTransitoTerceiro: null,
        ruaConversaoRealizadaEnvolvido: null,
        motivoPerdaControleVeiculoEnvolvido: null,
        razaoEnvolvidoCausouAcidente: null,
        sinalizacaoLocalAcidente: null,
        descricaoDetalhadaEnvolvido: null,
        infoSobreViaEventoEnvolvido: null,
        faixaTransitoEnvolvido: null,
      },
      listMotivos: [],
      listSituacoes: [],
      listEnvolvimentos: [],
      listResponsaveis: [],

      // Configurações de Component
      configDateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      customToolbar,
    };
  },
  computed: {
    tipoAbertura() {
      if (this.formData.isAberturaDigital) {
        return 'Digital';
      }

      if (this.formCadastroTerceiro.nomeUsuarioRealizouAbertura) {
        return `Manual, por ${this.formCadastroTerceiro.nomeUsuarioRealizouAbertura}`;
      }

      return `Manual`;
    },
    dataCadastroEvento() {
      return formatDate(this.formCadastroTerceiro.dataCadastro);
    },
  },
  methods: {
    validaHoraMinuto(newValue, campo) {
      if (newValue.length >= 5) {
        if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(newValue)) {
          notify.notifyFail(
            this.$vs,
            `Hora ${campo} inválida. Insira uma hora válida no formato HH:MM`,
          );
          this.formCadastroTerceiro[campo] = '';
        }
      }
    },
  },

  mounted() {
    if (!this.formData.cadastroTerceiro) {
      console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO TERCEIRO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.cadastroTerceiro = this.formCadastroTerceiro;

    this.listMotivos = this.dominios.listMotivos;
    this.listSituacoes = this.dominios.listSituacoes;
    this.listEnvolvimentos = this.dominios.listEnvolvimentos;
    this.listResponsaveis = this.dominios.listResponsaveis;
  },
};
</script>

<style scoped>
.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>

<style src="./../../../../../components/editor/style-editor.css"></style>
